<div class="container-plan">
  <table id="customers" aria-label="plan-table">
    <thead class="sticky-header">
      <tr>
        <th class="benefit-header">Beneficio</th>
        <th *ngFor="let plan of planNames" [ngClass]="isRecommendedPlan(plan) ? 'recommended-plan' : 'default-plan'">{{ plan }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container>
        <tr *ngFor= "let detail_plan of this.detail_plans"> 
          <td>
            {{ detail_plan.nombre_beneficio }}
            <br>
           <b><span *ngIf="detail_plan.glosa_beneficio !==''">{{ detail_plan.glosa_beneficio }}</span></b>
            <span class="icon-right" *ngIf="detail_plan.nombre_beneficio!==''">
              <div class="tooltip-container">
                <span class="tooltip-text">{{ detail_plan.nombre_beneficio }}</span>
                <img src="/assets/icono/info.svg" alt="" />
              </div>
            </span>
            <span class="revisar-right" *ngIf="detail_plan.nombre_beneficio===''"></span>
          </td>
          <td
            class="texto-centrado"
            *ngFor="let detalle_plan of getVisibleDetallePlan(detail_plan.detalle_plan); let planIndex = index"
            [ngClass]="isRecommendedPlan(planNames[planIndex]) ? 'recommended-plan-cell' : 'default-plan-cell'"
          >
            <p *ngIf="detalle_plan.aplica===true"><img src="/assets/icono/check.svg" alt="" /></p>
            <p *ngIf="detalle_plan.aplica===false"><img src="/assets/icono/equis.svg" class="icon-x-red" alt="No aplica" /></p>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
